import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import AuthenticationPageTemplate from '../../templates/AuthenticationPageTemplate'
import EnterBackupCode from '../../components/auth/EnterBackupCode'
import EnterSecurityCode from '../../components/auth/EnterSecurityCode'
import { useUser } from '../../context/CurrentUserContext'

const TwoFactorAuth = () => {
  const user = useUser()
  const { fetchUser } = useUser()
  const navigate = useNavigate()
  const location = useLocation()

  const [useBackupCodes, setUseBackupCodes] = useState(false)
  const [alert, setAlert] = useState(null)

  const verifyCode = async (code) => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_BASE_URL}/auth/2fa/verify`,
        {
          method: 'POST',
          body: JSON.stringify({ code }),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${location.state?.tempToken}`,
          },
        },
      )
      const data = await response.json()
      if (response.status === 200) {
        localStorage.setItem('accessToken', data.accessToken)
        localStorage.setItem('refreshToken', data.refreshToken)
        fetchUser()
        navigate('/')
      } else {
        if (response.status === 401) {
          navigate('/login', { state: { alert: data.message } })
        } else {
          setAlert({
            text: data.message ?? 'Could not verify code. Try again later.',
            color: 'error',
          })
        }
      }
    } catch (error) {
      setAlert({
        text: 'Could not verify code. Try again later.',
        color: 'error',
      })
      console.error('Could not verify code', error)
    }
  }

  useEffect(() => {
    if (location.state?.tempToken == null) {
      navigate('/')
    }
  })

  return (
    <AuthenticationPageTemplate
      showLogo={true}
      alert={alert}
      title={useBackupCodes ? 'Enter backup code' : 'Enter security code'}
      instructions={
        useBackupCodes ? (
          <>
            Enter the backup code you have saved when setting up two factor
            authentication.
          </>
        ) : (
          <>
            Enter the code from your authenticator app for the{' '}
            <b>{user?.user?.email}</b> account.
          </>
        )
      }
      onBackNavigation={() => navigate('/login')}
    >
      {useBackupCodes ? (
        <EnterBackupCode onConfirm={(code) => verifyCode(code)} />
      ) : (
        <EnterSecurityCode
          alert={alert}
          onConfirm={(code) => verifyCode(code)}
          useBackupCodes={() => {
            setUseBackupCodes(true)
          }}
        />
      )}
    </AuthenticationPageTemplate>
  )
}

export default TwoFactorAuth
